// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1bT61","label":"SetPasswdForm_label__208I2"};